import React, { useEffect, useRef } from 'react';

import Hls from 'hls.js';
import i18n from 'i18next';
import { toast } from 'react-toastify';

// FIXME перенести в кит

// Сессия ретранслятора прогревается после создания: манифест какое-то время может
// отвечать 4xx (404/401). hls.js 4xx не ретраит — ретраим подключение сами,
// чтобы плеер пережил прогрев вместо мгновенного отказа (как StreamPlayer в point3)
const MAX_MANIFEST_RETRIES = 20;
const MANIFEST_RETRY_DELAY_MS = 5000;

export function HLSPlayer({
  src,
  token,
  className = undefined,
  autoPlay = true,
  controls = true,
  muted = false,
  width = '100%',
  height = 'auto',
  onLoadedMetadata,
}) {
  const videoRef = useRef(null);

  useEffect(() => {
    const video = videoRef.current;
    if (!video || !src) return undefined;

    let hls;
    let manifestRetryTimeout;
    let manifestRetryCount = 0;
    let destroyed = false;

    const setup = () => {
      if (destroyed) return;

      if (!Hls.isSupported()) {
        console.error('HLS is not supported in this browser');
        toast.error(i18n.t('queue:hls player.errors.not supported'));
        return;
      }

      hls = new Hls({
        xhrSetup: (xhr) => {
          if (token) {
            xhr.setRequestHeader('Authorization', `Bearer ${token}`);
          }
          // eslint-disable-next-line no-param-reassign
          xhr.withCredentials = false;
        },
      });

      hls.loadSource(src);
      hls.attachMedia(video);

      hls.on(Hls.Events.ERROR, (event, data) => {
        if (!data.fatal) return;

        const isManifestLoadError = data.details === Hls.ErrorDetails.MANIFEST_LOAD_ERROR
          || data.details === Hls.ErrorDetails.MANIFEST_LOAD_TIMEOUT;

        if (isManifestLoadError && manifestRetryCount < MAX_MANIFEST_RETRIES) {
          manifestRetryCount += 1;
          hls.destroy();
          hls = undefined;
          manifestRetryTimeout = window.setTimeout(setup, MANIFEST_RETRY_DELAY_MS);
          return;
        }

        // FIXME Подумать над добавлением методов hls для восстановления трансляции при data.type:
        //  Hls.ErrorTypes.NETWORK_ERROR метод hls.recoverMediaError()
        //  Hls.ErrorTypes.MEDIA_ERROR метод hls.startLoad();;
        console.error('HLS fatal error:', data);
      });
    };

    setup();

    return () => {
      destroyed = true;
      if (manifestRetryTimeout) {
        window.clearTimeout(manifestRetryTimeout);
      }
      if (hls) {
        hls.destroy();
      }
      video.pause();
      video.removeAttribute('src');
      video.load();
    };
  }, [src, token]);

  return (
    // eslint-disable-next-line jsx-a11y/media-has-caption
    <video
      aria-label="HLS Player"
      autoPlay={autoPlay}
      className={className}
      controls={controls}
      height={height}
      muted={muted}
      onLoadedMetadata={onLoadedMetadata}
      ref={videoRef}
      width={width}
    />
  );
}
